import { PollOptionWithResult } from '@core/types';
import { PollResultPercentage, PollResultRatio, SSPollResultBar, SSPollResultLabel } from '../../../../index';

interface Props {
    index: number;
    option: PollOptionWithResult;
    totalVotes: number;
    showPercentagesOnly?: boolean;
}

export const SSPollResult = ({ index, option, totalVotes, showPercentagesOnly }: Props) => (
    <li className="flex border-dashed border-b-2 border-primary last:border-b-0 py-2 select-none">
        <SSPollResultLabel index={index} />
        <div className="relative inline-block flex-1" data-testid="PollResultBar">
            <div className="mb-2" data-testid="PollAnswerData">
                {option.text}
            </div>
            <SSPollResultBar votes={option.weightedVotes} totalVotes={totalVotes} />
            <div className={`flex ${showPercentagesOnly ? 'justify-end' : 'justify-between'}`}>
                {!showPercentagesOnly && <PollResultRatio votes={option.weightedVotes} totalVotes={totalVotes} />}
                <PollResultPercentage votes={option.weightedVotes} totalVotes={totalVotes} />
            </div>
        </div>
    </li>
);
